import React from 'react';

import { ReactComponent as DoubleArrowsIcon } from '@assets/svg/double_v_arrows.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  downtimeType: number;
  onClick: () => void;
}

const MetricsFieldType = ({ downtimeType, onClick }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={style.rightFieldBtn} onClick={() => onClick()}>
      <span className={style.fieldMark}>{t(downtimeType === 0 ? 'hours' : 'minutes')}</span>
      <DoubleArrowsIcon className={style.arrowsIcon} />
    </div>
  );
};

export default MetricsFieldType;
